import * as THREE from 'three';

/** Optional GLB node extras, evaluated by the same audio-synchronized mixer as motion. */
export function particleOpacityClip(root: THREE.Object3D, duration: number): THREE.AnimationClip | null {
  const tracks: THREE.NumberKeyframeTrack[] = [];
  root.traverse((object) => {
    if (!(object instanceof THREE.Mesh) || Array.isArray(object.material)) return;
    const data = object.userData.shisekiOpacity as { times?: unknown; values?: unknown } | undefined;
    if (!data) return;
    const { times, values } = data;
    if (
      !Array.isArray(times) || !Array.isArray(values) || times.length < 2 || times.length !== values.length ||
      !times.every((t: unknown, i: number) => typeof t === 'number' && Number.isFinite(t) && t >= 0 && t <= duration && (i === 0 || t > times[i - 1])) ||
      !values.every((v: unknown) => typeof v === 'number' && Number.isFinite(v) && v >= 0 && v <= 1)
    ) return;
    // GLTFLoader shares materials across particles. Clone only the fading particles.
    object.material = object.material.clone();
    object.material.transparent = true;
    object.material.depthWrite = false;
    object.material.forceSinglePass = true;
    object.material.opacity = values[0];
    tracks.push(new THREE.NumberKeyframeTrack(`${object.uuid}.material.opacity`, times, values));
  });
  return tracks.length ? new THREE.AnimationClip('shiseki_particle_opacity', duration, tracks) : null;
}
